export const MALE = 'Мужской';
export const FEMALE = 'Женский';

export enum GenderType {
	MALE = 'MALE',
	FEMALE = 'FEMALE',
}

export const getGenderTypeText = (value?: GenderType | string) => {
	switch (value) {
		case GenderType.MALE:
			return MALE;
		case GenderType.FEMALE:
			return FEMALE;
		default:
			return value;
	}
};
